const regexUtils = {
  // 正则表达式特殊字符
  specialChars: ['$', '(', ')', '*', '+', '.', '[', ']', '?', '\\', '^', '{', '}', '|'],
  // 转义特殊字符
  escapeRegExp: function (text) {
    let newText = ''
    if (text) {
      for (let i = 0; i < text.length; i++) {
        let char = text.charAt(i)
        newText += this.specialChars.includes(char) ? '\\' + char : char
      }
    }
    return newText
  }
}

export default regexUtils
